import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=911009f6"
import script from "./VideoDialog.vue?vue&type=script&lang=js"
export * from "./VideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports